import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import DatePicker from 'react-date-picker';
import moment from 'moment';

const SearchTemplateByReleaseDate = ({ releaseDate, setReleaseDate }) => {
  const onReleaseDateChange = (date) => {
    let dateStr;
    setReleaseDate(date === null ? undefined : date);

    if (date !== null) {
      dateStr = moment(date).format('YYYY-MM-DD');
    } else {
      dateStr = null;
    }
    setReleaseDate(dateStr);
  };

  return (
    <FormGroup style={styles.searchContainer}>
      <Label for="datePicker">Search by release date</Label>
      <DatePicker
        id="datePicker"
        name="datePicker"
        locale="fr-FR"
        onChange={onReleaseDateChange}
        showLeadingZeros
        value={releaseDate && releaseDate !== null ? moment(releaseDate, 'YYYY-MM-DD').toDate() : undefined}
      />
    </FormGroup>
  );
};

const styles = {
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15,
  },
  searchInput: {
    width: 400,
  },
};

export default SearchTemplateByReleaseDate;



// WEBPACK FOOTER //
// ./src/components/templates-manager/search-bar/search-templates-releaseDate.js